import { useQuery } from '@apollo/client';
import { FETCH_POLICY } from 'common/apollo/FETCH_POLICY';
import { GET_ALL_JOB_FAMILY_GROUP_DATA, UseGetAllJobFamilyGroupData } from './jobFamilyGroups.graphql';

const ALL_FAMILY_GROUPS = 10000;
const NO_OFFSET = 0;

export const useGetAllJobFamilyGroupData = () => {
  const { loading: gettingFullData } = useQuery<
    UseGetAllJobFamilyGroupData,
    {
      search?: string;
      limit: number;
      offset: number;
    }
  >(GET_ALL_JOB_FAMILY_GROUP_DATA, {
    fetchPolicy: FETCH_POLICY.CACHE_FIRST,
    variables: { limit: ALL_FAMILY_GROUPS, offset: NO_OFFSET }
  });

  return { gettingFullData };
};
